module.exports = __webpack_public_path__ + "media/images/emoticons/moon3-821b9de52a17e83ad8fdf5824fa26582.gif";